// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","2808":"f34e0124","5984":"02e86de9","6513":"f94f0740","7569":"9b0cb96b","8245":"1b5271a8","8719":"1b5271a8"}[chunkId] + ".chunk.css";
};